import { GitLogPanel, type Props } from "./GitLogPanel";

export function GitLogTab(props: Props) {
  return (
    <GitLogPanel
      key={JSON.stringify([
        props.conversationId,
        props.selection.workspaceId,
        props.selection.repositoryId,
      ])}
      {...props}
    />
  );
}
